import { useLocation } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";

/** Convierte hex a rgba(r,g,b, opacity). */
function hexToRgba(hex, opacity) {
  if (!hex || typeof hex !== "string") return `rgba(0,0,0,${opacity})`;
  const h = hex.replace(/^#/, "");
  const r = parseInt(h.length === 3 ? h[0] + h[0] : h.slice(0, 2), 16);
  const g = parseInt(h.length === 3 ? h[1] + h[1] : h.slice(2, 4), 16);
  const b = parseInt(h.length === 3 ? h[2] + h[2] : h.slice(4, 6), 16);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return `rgba(0,0,0,${opacity})`;
  return `rgba(${r},${g},${b},${opacity})`;
}

/**
 * Fondo con trama de puntos y color de body para /candidatos y /dashboard.
 * Para /formularios el fondo se aplica solo en la columna derecha (en el layout de Formularios).
 */
export function AppBackground() {
  const location = useLocation();
  const {
    backgroundDotSize,
    backgroundGridSize,
    backgroundDotOpacity,
    backgroundDotColor,
    bodyBackgroundColor,
  } = useSettings();

  const pathname = location.pathname || "";
  const showFullPageBackground =
    pathname === "/candidatos" ||
    pathname.startsWith("/candidatos/") ||
    pathname === "/dashboard" ||
    pathname === "/brutalfiles";

  if (!showFullPageBackground) return null;

  const dotSizePx = Math.max(0.5, Math.min(8, Number(backgroundDotSize) || 2));
  const gridSizePx = Math.max(8, Math.min(80, Number(backgroundGridSize) || 24));
  const opacity = Math.max(0, Math.min(1, Number(backgroundDotOpacity) ?? 0.12));
  const bgColor = bodyBackgroundColor || "#ffffff";
  const dotColor = hexToRgba(backgroundDotColor || "#000000", opacity);

  return (
    <div
      aria-hidden
      className="fixed inset-0 z-0 pointer-events-none"
      style={{
        backgroundColor: bgColor,
        backgroundImage: `radial-gradient(circle at center, ${dotColor} ${dotSizePx}px, transparent ${dotSizePx}px)`,
        backgroundSize: `${gridSizePx}px ${gridSizePx}px`,
      }}
    />
  );
}

/**
 * Estilo inline para aplicar la misma trama en un contenedor (ej. columna derecha en Formularios).
 */
export function getDotPatternStyle(settings) {
  const dotSizePx = Math.max(0.5, Math.min(8, Number(settings?.backgroundDotSize) ?? 2));
  const gridSizePx = Math.max(8, Math.min(80, Number(settings?.backgroundGridSize) ?? 24));
  const opacity = Math.max(0, Math.min(1, Number(settings?.backgroundDotOpacity) ?? 0.12));
  const bgColor = settings?.bodyBackgroundColor || "#ffffff";
  const dotColor = hexToRgba(settings?.backgroundDotColor || "#000000", opacity);
  return {
    backgroundColor: bgColor,
    backgroundImage: `radial-gradient(circle at center, ${dotColor} ${dotSizePx}px, transparent ${dotSizePx}px)`,
    backgroundSize: `${gridSizePx}px ${gridSizePx}px`,
  };
}
